// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.contactemail.RentalManagerUserPropertyContactEmailV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyContactEmailV2WebApiHandler_purge } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyContactEmailDeliverabilityResponseV2WebDto,
  UserPropertyContactEmailPurgeV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyContactEmailV2WebApiHandler_purge_Args {
  postData: UserPropertyContactEmailPurgeV2RequestDto;
}

export type RentalManagerUserPropertyContactEmailV2WebApiHandler_purge_Options = UseMutationOptions<
  UserPropertyContactEmailDeliverabilityResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyContactEmailV2WebApiHandler_purge_Args
>;

/**
 * Purge contact email with bounce or spam report
 */
export const useRentalManagerUserPropertyContactEmailV2WebApiHandler_purge = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyContactEmailV2WebApiHandler_purge_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyContactEmailV2WebApiHandler_purge_Args) =>
      RentalManagerUserPropertyContactEmailV2WebApiHandler_purge(args.postData, httpClient),
  });
};
